import React from 'react';
import { Section, SectionHead, Card, CardText } from './primitives';

const PILLARS = [
  {
    tag: 'Time',
    title: 'Ship in weeks, not quarters',
    body: 'Start from a working platform instead of a blank repo. Your team spends its time on strategy and distribution, not on plumbing order state machines.',
  },
  {
    tag: 'Control',
    title: 'Your perimeter, your rules',
    body: 'Everything runs in infrastructure you own. Positions, prompts, research output, and user data never leave your account.',
  },
  {
    tag: 'Economics',
    title: 'You own the relationship',
    body: 'Your brand, your pricing, your users, your Hyperliquid builder code. We license the software; the business you build on it is yours.',
  },
];

export const ValuePillars = () => (
  <Section id="why">
    <SectionHead
      eyebrow="The case"
      title="Two years of agentic trading infrastructure, ready to deploy under your name."
      lede="Building this from scratch means a research pipeline, an agent orchestration layer, a risk engine, exchange integration, order lifecycle management, and a front end traders will actually use. Katbot is all of that, running in production today — and now available as a licensed install."
    />
    <div className="grid gap-[18px] sm:grid-cols-2 lg:grid-cols-3">
      {PILLARS.map((p) => (
        <Card key={p.tag} tag={p.tag} title={p.title}>
          <CardText>{p.body}</CardText>
        </Card>
      ))}
    </div>
  </Section>
);

export default ValuePillars;
